import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShownTaskForm, useTaskFormStore } from "../../stores/useTaskFormStore";
import { useMeetingStore } from "../../stores/useMeetingStore";
import { useUserStore } from "../../stores/useUserStore";  // ✅ 新增
import { useForm } from "react-hook-form";
import useAxios from "../api/useAxios";
import useShowError from "../utils/useShowError";
import { useShowFormError } from "../utils/useShowFormError";
import IMeeting from "../../api/IMeeting";

const useAddJiraTaskForm = () => {
    const meeting = useMeetingStore((state) => state.meeting);
    const user = useUserStore((state) => state.user);  // ✅ 新增：获取 user
    const setMeeting = useMeetingStore((state) => state.setMeeting);
    const setForm = useTaskFormStore((state) => state.setForm);
    const setOpen = useTaskFormStore((state) => state.setOpen);

    const [bugs, setBugs] = useState(false);
    const [linked, setLinked] = useState(true);
    const [done, setDone] = useState(false);

    const toggleBugs = () => setBugs((prev) => !prev);
    const toggleLinked = () => setLinked((prev) => !prev);
    const toggleDone = () => setDone((prev) => !prev);

    const { error, loading, setError, clearError, post } = useAxios();  // ✅ 改为 post
    useShowError(error, clearError);

    const {
        control,
        formState: { errors, submitCount },
        clearErrors,
        handleSubmit,
        reset,
    } = useForm<{ issueId: string }>({
        defaultValues: {
            issueId: "",
        },
    });
    useShowFormError(errors, submitCount, clearErrors);

    useEffect(() => {
        if (!meeting?.jiraConnected) setForm(ShownTaskForm.JiraSetup);
    }, [meeting?.id]);

    const close = () => {
        reset();
        setOpen(false);
    };

    const submit = handleSubmit(async (data) => {
        if (!meeting) return setError(`Missing Meeting`);
        if (!user) return setError(`Missing User`);  // ✅ 新增校验

        // ✅ 新增：构建 authValues 对象
        const authValues = {
            meetingId: meeting.id,
            email: user.jiraEmail,
            token: user.jiraToken,
        };

        // ✅ 改为 POST 请求，authValues 在 body 中
        let res = await post<IMeeting>(
            `/api/meeting/GetJiraIssue?issueId=${data.issueId.trim()}&linked=${linked}&bugs=${bugs}&done=${done}`,
            authValues
        );

        if (res) setMeeting(res);

        close();
    });

    return {
        control,
        loading,
        bugs,
        linked,
        done,
        submit,
        close,
        toggleBugs,
        toggleLinked,
        toggleDone,
    };
};

export default useAddJiraTaskForm;